import React, { useState } from "react";
import * as styles from "./ReadMore.module.scss";
import classNames from "classnames/bind";
import { Button } from "@silversea-ssc/ui-components-react";
import { ComponentBackgroundColor } from "types/componentBackground";

const cx = classNames.bind(styles);

export interface ReadMoreProps {
  openLabel: string | JSX.Element;
  closeLabel: string | JSX.Element;
  className?: string;
  height?: string;
  backgroundColor?: ComponentBackgroundColor;
}

const ReadMore: React.FC<ReadMoreProps> = ({
  openLabel,
  closeLabel,
  className = undefined,
  height = "150px",
  children,
  backgroundColor = "white"
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={cx({
        expanded: expanded,
        backgroundWhite: backgroundColor == "white",
        backgroundGray: backgroundColor == "neutral05",
        [className || ""]: className
      })}
    >
      <div
        className={styles.content}
        style={{ maxHeight: expanded ? "auto" : height }}
      >
        {children}
      </div>

      <Button
        renderAs="button"
        className={styles.button}
        variant="link"
        iconName={expanded ? "close" : "plus"}
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        {expanded ? closeLabel : openLabel}
      </Button>
    </div>
  );
};

export default ReadMore;
